import { call, put, takeEvery } from "redux-saga/effects"
import { FORM_NAMES } from "constants/index"
import { showToast } from "../../utils"
import {
  GET_BUSINESS_UNITS,
  GET_BUSINESS_UNIT,
  CREATE_BUSINESS_UNIT,
  DELETE_BUSINESS_UNIT,
  UPDATE_BUSINESS_UNIT,
} from "./actionTypes"
import {
  getBusinessUnitsSuccess,
  getBusinessUnitsFail,
  getBusinessUnitSuccess,
  getBusinessUnitFail,
  deleteBusinessUnitSuccess,
  deleteBusinessUnitFail,
  hideDeleteModal,
  createBusinessUnitSuccess,
  createBusinessUnitFail,
  updateBusinessUnitSuccess,
  updateBusinessUnitFail,
} from "./actions"
import { LOCAL_STORAGE_TAGS } from "constants/index"
import { get, post, del, axiosPut } from "helpers/api_helper"
import * as url from "helpers/url_helper"

function* getBusinessUnitsSaga({ payload: params }) {
  let vendorId =
    params && params.params && params.params.vendor_id
      ? params.params.vendor_id
      : yield localStorage.getItem(LOCAL_STORAGE_TAGS.VENDOR_ID_TAG)
  try {
    const response = yield get(
      url.GET_ADMIN_BUSINESS_UNITS + "/" + vendorId,
      params
    )
    yield put(getBusinessUnitsSuccess(response))
  } catch (error) {
    yield put(getBusinessUnitsFail(error))
  }
}

function* fetchBusinessUnit({ payload: params }) {
  try {
    const response = yield get(url.GET_BUSINESS_UNIT_URL + params.params.id)
    yield put(getBusinessUnitSuccess(response))
  } catch (error) {
    yield put(getBusinessUnitFail(error))
    showToast("error", error, "Error")
  }
}

function* createBusinessUnit({ payload }) {
  try {
    yield post(url.CREATE_BUSINESS_UNIT_URL, payload?.values)
    yield put(createBusinessUnitSuccess())
    showToast("success", "The business unit was created!", "Success")
    if (payload?.callback) {
      payload?.callback()
    }
  } catch (error) {
    yield put(createBusinessUnitFail(error))
    showToast("error", error, "Error")
  }
}

function* updateBusinessUnit({ payload }) {
  try {
    yield axiosPut(
      url.UPDATE_BUSINESS_UNIT_URL + payload?.values?.id,
      payload?.values
    )
    yield put(updateBusinessUnitSuccess())
    showToast("success", "The business unit was updated!", "Success")
    if (payload?.callback) {
      payload?.callback()
    }
  } catch (error) {
    yield put(updateBusinessUnitFail(error))
    showToast("error", error, "Error")
  }
}

function* deleteBusinessUnit({ payload }) {
  try {
    yield del(url.DELETE_BUSINESS_UNIT_URL + payload.params.id)
    yield put(deleteBusinessUnitSuccess())
    yield put(hideDeleteModal())
    showToast("success", "The business unit was deleted!", "Success")
    if (payload?.params?.callback) {
      payload?.params?.callback()
    }
  } catch (error) {
    yield put(deleteBusinessUnitFail(error))
    showToast("error", error, "Error")
  }
}

function* businessUnitsSaga() {
  yield takeEvery(GET_BUSINESS_UNITS, getBusinessUnitsSaga)
  yield takeEvery(GET_BUSINESS_UNIT, fetchBusinessUnit)
  yield takeEvery(CREATE_BUSINESS_UNIT, createBusinessUnit)
  yield takeEvery(DELETE_BUSINESS_UNIT, deleteBusinessUnit)
  yield takeEvery(UPDATE_BUSINESS_UNIT, updateBusinessUnit)
}

export default businessUnitsSaga()
